<template>
    <date-filter v-model="dates" label="Last visit"></date-filter>
</template>

<script>
import DateFilter from "@/components/DateFilter";

export default {
    name: "BirthDateFilter",
    components: { DateFilter },
    props: {
        value: null
    },
    data() {
        return {
            dates: {}
        }
    },
    watch: {
        dates: {
            handler(newVal) {
                if (!(newVal.start && newVal.end)) {
                    this.$emit('input', {})
                    this.$emit('change', {})
                    return
                }
                const query = {
                    lastVisit: {
                        $gt: newVal.start,
                        $lt: newVal.end
                    }
                }
                this.$emit('input', query)
                this.$emit('change', query)
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
